import {
  FinanceInfoDetailedFields,
  FinanceInfoVisibleFields,
  GeneralLoanInfoDetailedFields,
  GeneralLoanInfoVisibleFields,
  ProductInfoDetailedFields,
  ProductInfoVisibleFields,
  SubjectPropertyDetailedFields,
  SubjectPropertyVisibleFields
} from "./fields";
import { SchemaVersionEnum } from "./schema";
import { filterFieldsNotIncludedInDefaultSchema } from "../services/schemaTools";
const EmptySchema = {
  version: SchemaVersionEnum.V3,
  schema: {
    theme: null,
    modules: [],
    screens: [
      {
        type: "screen_group",
        screens: []
      }
    ]
  },
  schemaRules: []
};
const NSSampleSchema = {
  version: SchemaVersionEnum.V3,
  schema: {
    theme: null,
    modules: [],
    screens: [
      {
        type: "screen_group",
        screens: [
          {
            // Refers to screens below
            id: "c8fc0171-c0c4-46fd-b81e-0c2e315512e2"
          },
          {
            id: "56cac222-e97d-4993-81c7-a0d86a92244a"
          },
          {
            id: "3cd6556e-a5e0-4c02-95ae-8da91a866ea0"
          },
          {
            id: "66cb28eb-7754-499e-bc0c-c399728f9598"
          }
        ]
      },
      {
        id: "c8fc0171-c0c4-46fd-b81e-0c2e315512e2",
        type: "screen",
        name: "General Loan Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: GeneralLoanInfoVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: GeneralLoanInfoDetailedFields
          }
        ]
      },
      {
        id: "56cac222-e97d-4993-81c7-a0d86a92244a",
        type: "screen",
        name: "Product Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: filterFieldsNotIncludedInDefaultSchema(
              ProductInfoVisibleFields
            )
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: ProductInfoDetailedFields
          }
        ]
      },
      {
        id: "3cd6556e-a5e0-4c02-95ae-8da91a866ea0",
        type: "screen",
        name: "Finance Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: FinanceInfoVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: FinanceInfoDetailedFields
          }
        ]
      },
      {
        id: "66cb28eb-7754-499e-bc0c-c399728f9598",
        type: "screen",
        name: "Subject Property Information",
        fields: [
          {
            type: "field_group",
            name: "VISIBLE",
            fields: SubjectPropertyVisibleFields
          },
          {
            type: "field_group",
            name: "DETAILED",
            fields: SubjectPropertyDetailedFields
          }
        ]
      }
    ]
  },
  schemaRules: [
    {
      name: "Loan is HELOC",
      id: "213beec3-7caf-45be-9cec-67359ee890b3",
      modifiedOn: "1742246221430",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "74ec6dbb-0ea7-4686-9d75-93ad36660f26",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["productType", "66"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["productType", "21"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["productType", "64"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["productType", "117"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["productType", "77"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["productType", "90"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["productType", "65"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["productType", "67"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "User Rights: Can Set Loan Officer",
      id: "62af1e06-20c3-4904-ba36-166c5ba2daf1",
      modifiedOn: "1742823745518",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "7d5c581a-9e93-4bf9-ad6b-2962f0d190ae",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["nonLoanValues.canAssignLoanOfficer", "true"]
              },
              {
                op: "352c67e6-5cbc-4795-a066-92739c5bd961"
              }
            ]
          }
        }
      ]
    },
    {
      name: "Is Buyside, Sellside, or Validate View",
      id: "352c67e6-5cbc-4795-a066-92739c5bd961",
      modifiedOn: "1742823745518",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "fbe175cb-4887-480c-ad45-acdfc909734d",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["nonLoanValues.isBuyside", "false"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["nonLoanValues.isSellside", "false"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["nonLoanValues.isValidate", "false"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Has No Buydown Type",
      id: "37de09f3-d2b4-42f8-bb50-70ee907b870a",
      modifiedOn: "1744232516461",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "278360a1-149c-48c9-9b8c-085c3a4f0a87",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["buydownType", "0"]
              },
              {
                op: "isEmptyField",
                params: ["buydownType"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Loan is First Mortgage & HELOC",
      id: "322159db-fd06-4203-88cc-ba7dd14707bc",
      modifiedOn: "1742823745518",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "7d5c581a-9e93-4bf9-ad6b-2962f0d190ae",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "213beec3-7caf-45be-9cec-67359ee890b3"
              },
              {
                op: "eddabb96-3e46-429f-93e8-3d33e02e4639"
              }
            ]
          }
        }
      ]
    },
    {
      name: "Loan is Second Mortgage & HELOC",
      id: "f377baba-059d-423f-8702-de8281d8ec57",
      modifiedOn: "1742823857019",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "cad58c5a-22d8-4b8a-b193-0c68ac90e38a",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "213beec3-7caf-45be-9cec-67359ee890b3"
              },
              {
                op: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
              }
            ]
          }
        }
      ]
    },
    {
      name: "Loan is Cash Out Refinance",
      id: "d72d3321-a47a-4b43-be78-54a8a7e0ced2",
      modifiedOn: "1742824013136",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "3234cf2e-026f-46cb-9f22-7859e3f782a6",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isFieldNotEqualToValue",
                params: ["loanInformation.loanPurpose", "3"]
              },
              {
                op: "213beec3-7caf-45be-9cec-67359ee890b3"
              }
            ]
          }
        }
      ]
    },
    {
      name: "Hide Commitment And Delivery Type",
      id: "b8e31c77-8a8f-4f43-b748-ab4d3404fa3d",
      modifiedOn: "1743622153822",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "c08bc7cc-e5d9-492e-9d51-a647639b331c",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isFieldNotEqualToValue",
                params: ["nonLoanValues.loanChannel", "4"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["nonLoanValues.viewDeliveryAndCommitment", "false"]
              },
              {
                op: "f34ac495-78b1-4884-9833-58a786f9d15f"
              }
            ]
          }
        }
      ]
    },
    {
      name: "Is Banked - Wholesale and TPO UI",
      id: "f34ac495-78b1-4884-9833-58a786f9d15f",
      modifiedOn: "1743622135426",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "be14b89e-e650-4816-9100-65301269a79c",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["nonLoanValues.isTPO", "true"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["nonLoanValues.loanChannel", "2"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Loan has Supplemental Funding",
      id: "835dd9a9-6ed0-4614-9e3b-3fc3e967eddd",
      modifiedOn: "1743022983199",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "35031db6-a357-4f00-93c5-1aee90f9a27b",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldNotEqualToValue",
                params: ["loanInformation.lienPosition", "2"]
              },
              {
                op: "isFieldNotEqualToValue",
                params: ["loanInformation.loanPurpose", "2"]
              },
              {
                op: "isFieldNotEqualToValue",
                params: ["loanInformation.loanPurpose", "3"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Loan is Govt Loan",
      id: "dc1c8abd-0d8e-4d6f-ba01-36e484bccc05",
      modifiedOn: "1742824147814",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "f2255246-484b-40b6-8580-d04a81e8ab59",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["standardProducts", "2"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["standardProducts", "3"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["standardProducts", "4"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["specialProducts", "136"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Loan is Not Govt Loan",
      id: "5913ae87-8bbf-42ff-9b66-2025a5d84fb3",
      modifiedOn: "1742824147814",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "faf3510c-9d34-4f6d-b2e4-7a9b3267e0e3",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldNotEqualToValue",
                params: ["standardProducts", "2"]
              },
              {
                op: "isFieldNotEqualToValue",
                params: ["standardProducts", "3"]
              },
              {
                op: "isFieldNotEqualToValue",
                params: ["standardProducts", "4"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Hide Govt Fee Fields",
      id: "26722b03-3fbc-4729-ab8c-fd56f6528aa6",
      modifiedOn: "1742824147814",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "a8cc8af8-edfb-4688-a0f6-d0b632a42f81",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              // is VA Exempt
              {
                op: "014fd3e9-37c9-4570-a0a7-32553fb1a06b"
              },
              // has no fee factor
              {
                op: "isEmptyField",
                params: ["govtFeeFactor"]
              },
              // Is not a govt loan
              {
                op: "5913ae87-8bbf-42ff-9b66-2025a5d84fb3"
              }
            ]
          }
        }
      ]
    },
    {
      name: "VA Exempt",
      id: "014fd3e9-37c9-4570-a0a7-32553fb1a06b",
      modifiedOn: "1742824147814",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "e4bb5038-3625-4a66-b212-d26177fa9735",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              // Is VA
              {
                op: "isFieldEqualToValue",
                params: ["standardProducts", "3"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.vaFundingFeeExempted", "true"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Show Govt Fee Factor",
      id: "7e6d083d-a226-41f5-b9c6-7c8d58c650eb",
      modifiedOn: "1742824147814",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "71501f85-bcd2-498e-b036-8076b3dbf5ac",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "dc1c8abd-0d8e-4d6f-ba01-36e484bccc05"
              },
              {
                op: "isNotEmptyField",
                params: ["govtFeeFactor"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Has Target Label Price",
      id: "4a43e7d4-a2a0-4e51-a01b-2f5d943b60a0",
      modifiedOn: "1744233092916",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "9c4215de-d7f2-4b06-a818-dd6b53243a1f",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.targetLabel", "Price"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Has Target Label Rate",
      id: "db74b73a-2117-43db-9352-ef915287f987",
      modifiedOn: "1742840465936",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "adc02132-0d61-4510-8fb3-981733e73119",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.targetLabel", "Rate"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Loan is Subordinate HELOC",
      id: "96052c26-2b63-4c86-a969-6f86c0166187",
      modifiedOn: "1742245724801",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "76a06859-b79d-4465-a3bd-45488cc29c38",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.lienPosition", 1]
              },
              {
                op: "213beec3-7caf-45be-9cec-67359ee890b3"
              }
            ]
          }
        }
      ]
    },
    {
      isPreConfigured: true,
      modifiedOn: "1739919294689",
      name: "Loan is Refinance",
      type: "rule",
      id: "49cf07c3-2f06-41a1-8c5e-64580fa0730b",
      instructions: [
        {
          id: "149de332-f34f-43de-a560-49ae3bb9f3f8",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.loanPurpose", 2]
              },
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.loanPurpose", 3]
              }
            ]
          }
        }
      ]
    },
    {
      isPreConfigured: true,
      modifiedOn: "1739919294689",
      name: "Loan has Second Mortgage Value",
      type: "rule",
      id: "efe3a42a-b0a2-4330-801c-6a637537a19b",
      instructions: [
        {
          id: "952ced8a-513e-491d-af21-75c2a86339e1",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isNotEmptyField",
                params: ["loanInformation.secondMortgageAmount"]
              },
              {
                op: "isNotEmptyField",
                params: ["loanInformation.otherPayment"]
              }
            ]
          }
        }
      ]
    },
    {
      isPreConfigured: true,
      modifiedOn: "1739919294689",
      name: "Loan is Lien Position Second Mortgage",
      type: "rule",
      id: "305c1831-0004-4a2e-8cdb-6bf85c1a0029",
      instructions: [
        {
          id: "68a11ae4-7fa2-45db-8ed9-b2fddae4d44f",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.lienPosition", 2]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Hide Loan Amount",
      id: "ac5bf777-020a-45e2-9636-8bd4e7447a8f",
      modifiedOn: "1744050376003",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "e0c8010e-05d4-4f0a-a19d-845a85323f3f",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "322159db-fd06-4203-88cc-ba7dd14707bc"
              },
              {
                op: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
              }
            ]
          }
        }
      ]
    },
    {
      name: "Is Second Mortgage OR Heloc",
      id: "955b111f-f1c5-44de-8635-6a5fa6019ac9",
      modifiedOn: "1744053176215",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "40c14dea-9e74-438e-9347-9fc1430ee02b",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "213beec3-7caf-45be-9cec-67359ee890b3"
              },
              {
                op: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
              }
            ]
          }
        }
      ]
    },
    {
      name: "Is Alt Income or Full Income",
      id: "ef8adce9-1a09-4b33-8526-2702f7d12581",
      modifiedOn: "1744314753810",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "16089a15-d462-4d97-b2d9-67e9836ba839",
          type: "instruction",
          condition: {
            op: "or",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["borrowerFinancialHistory.docTypeIncome", "100"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["borrowerFinancialHistory.docTypeIncome", "70"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Show Label as Purchase Price/Property Value",
      id: "afd0dba5-5bdd-4405-967b-da2a51068583",
      modifiedOn: "1744917960733",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "67d7772c-6984-4747-b923-3361c9a6c8ab",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "eddabb96-3e46-429f-93e8-3d33e02e4639"
              },
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.loanPurpose", "1"]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Hide Non-QM Doc Level",
      id: "01fd7f37-f673-4de8-85fc-25de2d0855fc",
      modifiedOn: "1744314799017",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "52b3e59b-d286-4315-a854-c7a1fa518416",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "ef8adce9-1a09-4b33-8526-2702f7d12581"
              },
              {
                op: "isFieldEqualToValue",
                params: ["standardProducts", "6"]
              }
            ]
          }
        }
      ]
    },
    {
      isPreConfigured: true,
      modifiedOn: "1739919294689",
      name: "Loan is Lien Position First Mortgage",
      type: "rule",
      id: "eddabb96-3e46-429f-93e8-3d33e02e4639",
      instructions: [
        {
          id: "23a11ae4-7fa2-45db-8ed9-b2fddae4d44f",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["loanInformation.lienPosition", 1]
              }
            ]
          }
        }
      ]
    },
    {
      name: "Display DSCR",
      id: "829c15f3-68f2-4161-b44a-7361ec9d02bc",
      modifiedOn: "1747301736185",
      isPreConfigured: true,
      type: "rule",
      instructions: [
        {
          id: "fcdc6ee1-bde0-4f68-ac39-058fee7ce3c4",
          type: "instruction",
          condition: {
            op: "and",
            params: [
              {
                op: "isFieldEqualToValue",
                params: ["standardProducts", "6"]
              },
              {
                op: "isFieldEqualToValue",
                params: ["borrowerFinancialHistory.docTypeIncome", "0"]
              }
            ]
          }
        }
      ]
    }
  ]
};
const SamplePricingSearchConfigurationStore = [
  {
    channel: "Brokered",
    draftSchema: NSSampleSchema,
    modifiedOn: (/* @__PURE__ */ new Date()).getTime().toString(),
    publishedSchema: null,
    userLastEdited: "Dave"
  }
];
export {
  EmptySchema,
  NSSampleSchema,
  SamplePricingSearchConfigurationStore
};
